<template>
    <div v-show="visible">
        <el-dialog title="移动机构" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="70px">
                <el-form-item   prop="deptId" label="部门：">
                    <el-cascader
                        :options="depts"
                        v-model="form.deptId"
                        :props="props"
                        collapse-tags
                        clearable></el-cascader>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                form:{
                    deptId: "",
                    id: "",
                },
                queryForm:{
                    deptId: "",
                },
                rules: {
                    deptId: [ 
                        { required: true, message: '请选择部门', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
             init(ids, deptId){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.id = ids
                this.queryForm.deptId = deptId
                this.getDeptCascader()
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //部门
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {
                    deptId: this.queryForm.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data.selects; 
                    //  console.log("部门列表:"+JSON.stringify(this.depts))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    let deptId = this.filterCascader(this.form.deptId);

                    if(valid){
                        let url= this.moveUrl;
                        let data = {
                            id:this.form.id,
                            deptId:deptId
                        };
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message, 5,true);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array();
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
               return arrVal.join();
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/sys/user/Move.vue